import { render, staticRenderFns } from "./PartList.vue?vue&type=template&id=de25d834"
import script from "./PartList.vue?vue&type=script&lang=js"
export * from "./PartList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports